import { type ReactNode } from 'react';

interface PageSectionProps {
  children: ReactNode;
}

export const PageSection = ({ children }: PageSectionProps) => {
  return (
    <section className="l-section">
      <div className="l-section__line">
        <div className="l-container">{children}</div>
      </div>
    </section>
  );
};
